import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  action,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6 md:mb-8">
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs text-primary-600 bg-primary-50 border border-primary-100 px-2.5 py-1 rounded-full mb-3">
            <i className="ri-price-tag-3-line" aria-hidden="true"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
          {title}
        </h2>
        {desc && (
          <p className="mt-2 text-sm md:text-base text-foreground-500 leading-relaxed">
            {desc}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}